export default __webpack_public_path__ + "static/media/include_8_female@2x.cf8fe46f.jpg";